module.exports = __webpack_public_path__ + "static/img/weather18.be0bcf5a.png";